import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './style';
import { getSectionTheme, SECTIONS } from '../../theme/section-colors';
import usePlatform from 'lib/hooks/usePlatform';

const SectionHeading = ({ title, section = SECTIONS.DEFAULT, boxClassName = '', ...rest }) => {
    // ** Hooks
    const { isWebinarPlus } = usePlatform();
    const classes = useStyles({ ...getSectionTheme(isWebinarPlus ? SECTIONS.WP_DEFAULT : section), isWebinarPlus });
    return (
        <Box className={`${classes.sectionTitle} ${boxClassName}`}>
            <Typography
                component="h1"
                variant={isWebinarPlus ? "h5" : "h4"}
                {...rest}
            >
                {title}
            </Typography>
        </Box>
    )
}

export default SectionHeading